var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 40,
    viewBox: "0 0 147 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6241 33.56V15.08H50.8144V18.44H41.0806V23.48H50.2979V26.72H41.0806V33.56H37.6241Z",
    fill: "#15232B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8601 33.56V15.08H59.2769V33.56H55.8601Z",
    fill: "#15232B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4459 33.56H77.314L71.9505 27.4H68.6132V33.56H65.1567V15.04C68.057 15.04 70.997 15.08 73.8973 15.08C78.2675 15.08 80.5321 18 80.5321 21.2C80.5321 23.72 79.38 26.28 75.8838 27L81.4459 33.32V33.56ZM68.653 18.32V24.24H73.937C76.1221 24.24 77.0757 22.76 77.0757 21.28C77.0757 19.8 76.1221 18.32 73.937 18.32H68.653Z",
    fill: "#15232B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8213 19.52C96.1857 18.48 94.4773 17.48 92.4511 17.48C89.8686 17.48 88.637 18.56 88.637 19.92C88.637 21.52 90.544 21.96 92.7292 22.24C96.5432 22.72 100.119 23.72 100.119 28.12C100.119 32.24 96.5035 34 92.4113 34C88.6767 34 85.7765 32.84 84.4257 29.44L87.3259 27.92C88.1205 29.96 90.2659 30.84 92.4908 30.84C94.6759 30.84 96.7022 30.08 96.7022 28.08C96.7022 26.32 94.8746 25.64 92.4511 25.36C88.7165 24.92 85.26 23.92 85.26 19.76C85.26 15.96 88.9946 14.4 92.3716 14.36C95.2322 14.36 98.2119 15.16 99.5627 18.04L96.8213 19.52Z",
    fill: "#15232B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21 18.24H104.37V15.08C109.654 15.08 114.144 15.08 119.467 15.08V18.24H113.627V33.56H110.171V18.24H110.21Z",
    fill: "#15232B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.632 33.56V15.08H126.023V33.56H124.632Z",
    fill: "#15232B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.293 15.08L145.649 30.36V15.08H147.04V33.56H146.484L134.128 18.32V33.56H132.697V15.08H133.293Z",
    fill: "#15232B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0094 11.6C28.0094 11.28 27.9697 10.92 27.8902 10.64C27.8505 9.48 28.1683 7.76 30.4727 7.84C30.8302 7.96 31.1878 8 31.5851 8C33.7702 8 35.5581 6.2 35.5581 4C35.5581 1.8 33.7702 0 31.5851 0C29.4 0 27.6121 1.8 27.6121 4C27.6121 4.4 27.6519 4.76 27.771 5.12C27.7313 6.16 27.0162 7.6 23.6392 7.6H4.17158C1.98645 7.6 0.198608 9.4 0.198608 11.6C0.198608 15.04 2.97969 15.6 2.97969 15.6C4.09212 15.6 4.96618 16.48 4.96618 17.6C4.96618 18.72 4.09212 19.6 2.97969 19.6C2.97969 19.6 0.198608 20.08 0.198608 23.6C0.198608 25.8 1.98645 27.6 4.17158 27.6H16.0905C18.2756 27.6 20.0635 25.8 20.0635 23.6C20.0635 21.4 18.2756 19.6 16.0905 19.6H8.93915C7.82672 19.6 6.95266 18.72 6.95266 17.6C6.95266 16.48 7.82672 15.6 8.93915 15.6H24.0364C26.2216 15.6 28.0094 13.8 28.0094 11.6ZM5.76077 31.6C3.57564 31.6 1.7878 33.4 1.7878 35.6C1.7878 37.8 3.57564 39.6 5.76077 39.6C7.94591 39.6 9.73374 37.8 9.73374 35.6C9.73374 33.4 7.94591 31.6 5.76077 31.6Z",
    fill: "url(#paint0_linear_1_3501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3501",
    x1: 35.5581,
    y1: 4.21715e-8,
    x2: 10.5078,
    y2: 45.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B01BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA3F85"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.79ca5cf76d70a3b7fa23eff31c0f0d1e.svg";
export { ForwardRef as ReactComponent };